import { useState } from "react";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { CircularProgress } from "@mui/material";
import { FaApple } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import { t } from "../../../../translations";
import { EmailValidation } from "../../../functions/validateEmailPassword";
import { openNotificationWithIcon } from "../../notification-bar";
import { validatePassword, validatePhoneNumber } from "../utils";
import PasswordRequirements from "../PasswordRequirements";

const TAB_EMAIL = "email";
const TAB_SMS = "sms";

const LoginMethodSelect = ({
  activeTab,
  setActiveTab,
  isSignUp,
  setIsSignUp,
  load,
  setLoad,
  showOtpStep,
  selectedLang,
  email,
  setEmail,
  password,
  setPassword,
  confirmPassword,
  setConfirmPassword,
  showPassword,
  setShowPassword,
  showConfirmPassword,
  setShowConfirmPassword,
  firstname,
  setFirstname,
  lastname,
  setLastname,
  phoneNumber,
  setPhoneNumber,
  onGoogleLogin,
  onAppleLogin,
  handlePasswordLogin,
  handlePasswordSignup,
  handlePasswordReset,
  onSendOtp,
  resetPasswordLoading,
  resetPasswordCooldown,
  validatePassword: validatePwd
}) => {
  const [smsPhoneInput, setSmsPhoneInput] = useState("");

  const handleEmailSubmit = () => {
    if (!EmailValidation(email)) {
      openNotificationWithIcon("error", t("navbar.wrong_email_notification", selectedLang));
      return;
    }
    if (isSignUp) {
      const passwordValidation = validatePwd(password);
      if (!passwordValidation.isValid) {
        openNotificationWithIcon("warning", t("navbar.password_requirements", selectedLang));
        return;
      }
      if (!confirmPassword) {
        openNotificationWithIcon("error", t("navbar.password_confirm_required", selectedLang));
        return;
      }
      if (password !== confirmPassword) {
        openNotificationWithIcon("error", t("navbar.passwords_not_match", selectedLang));
        return;
      }
      if (!firstname || !lastname) {
        openNotificationWithIcon("error", t("navbar.signup_firstname_lastname_notification", selectedLang));
        return;
      }
      if (!phoneNumber || !validatePhoneNumber(phoneNumber)) {
        openNotificationWithIcon("error", t("navbar.phone_invalid", selectedLang));
        return;
      }
      setLoad(true);
      handlePasswordSignup();
    } else {
      if (password.length < 8) {
        openNotificationWithIcon("warning", t("navbar.password_min_length_error", selectedLang));
        return;
      }
      setLoad(true);
      handlePasswordLogin();
    }
  };

  const handleSendOtp = () => {
    const digitsOnly = smsPhoneInput.replace(/\D/g, "");
    if (!validatePhoneNumber(digitsOnly)) {
      openNotificationWithIcon("error", t("navbar.phone_invalid", selectedLang));
      return;
    }
    if (load) return;
    setLoad(true);
    onSendOtp(digitsOnly);
  };

  return (
    <div className="log-in-up-menu">
      <h2>{t("navbar.welcome_pani", selectedLang)}</h2>
      {[
        {
          icon: <FcGoogle size={25} />,
          text: t("navbar.signup_google", selectedLang),
          fn: onGoogleLogin
        },
        {
          icon: <FaApple size={25} />,
          text: t("navbar.signup_apple", selectedLang),
          fn: onAppleLogin
        }
      ].map((item) => (
        <div
          className="log-in-up-item"
          key={item.text}
          onClick={() => !load && item?.fn()}
        >
          {item.icon}
          <span>{item.text}</span>
        </div>
      ))}

      <div style={{ display: "flex", gap: "10px", margin: "16px 0 10px 0" }}>
        <button
          type="button"
          onClick={() => setActiveTab(TAB_EMAIL)}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: activeTab === TAB_EMAIL ? "#ff114d" : "#f0f0f0",
            color: activeTab === TAB_EMAIL ? "white" : "#333",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          {t("navbar.signup_placeholder_email", selectedLang)}
        </button>
        <button
          type="button"
          onClick={() => setActiveTab(TAB_SMS)}
          style={{
            flex: 1,
            padding: "10px",
            backgroundColor: activeTab === TAB_SMS ? "#ff114d" : "#f0f0f0",
            color: activeTab === TAB_SMS ? "white" : "#333",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer"
          }}
        >
          {t("navbar.sms_login", selectedLang)}
        </button>
      </div>

      {activeTab === TAB_EMAIL && (
        <>
          <input
            placeholder={t("navbar.signup_placeholder_email", selectedLang)}
            onChange={(e) => setEmail(e.target.value)}
            value={email}
            type="email"
          />
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <input
              placeholder={t("navbar.password_placeholder", selectedLang)}
              onChange={(e) => setPassword(e.target.value)}
              value={password}
              type={showPassword ? "text" : "password"}
              style={{ width: "100%", paddingRight: "40px" }}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: "absolute",
                right: "10px",
                background: "none",
                border: "none",
                cursor: "pointer",
                padding: "5px"
              }}
            >
              {showPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
            </button>
          </div>
          {isSignUp && (
            <>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <input
                  placeholder={t("navbar.confirm_password_placeholder", selectedLang)}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  value={confirmPassword}
                  type={showConfirmPassword ? "text" : "password"}
                  style={{ width: "100%", paddingRight: "40px" }}
                />
                <button
                  type="button"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  style={{
                    position: "absolute",
                    right: "10px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    padding: "5px"
                  }}
                >
                  {showConfirmPassword ? <AiFillEyeInvisible size={20} /> : <AiFillEye size={20} />}
                </button>
              </div>
              <input
                placeholder={t("navbar.signup_placeholder_firstname", selectedLang)}
                onChange={(e) => setFirstname(e.target.value)}
                value={firstname}
                type="text"
              />
              <input
                placeholder={t("navbar.signup_placeholder_lastname", selectedLang)}
                onChange={(e) => setLastname(e.target.value)}
                value={lastname}
                type="text"
              />
              <input
                placeholder={t("navbar.phone_number", selectedLang)}
                onChange={(e) => setPhoneNumber(e.target.value.replace(/\D/g, "").slice(0, 10))}
                value={phoneNumber}
                type="tel"
              />
            </>
          )}
          {!isSignUp && (
            <button
              type="button"
              className="forgot-password-link"
              onClick={handlePasswordReset}
              disabled={resetPasswordLoading || resetPasswordCooldown}
            >
              {resetPasswordLoading
                ? t("navbar.reset_password_sending", selectedLang)
                : resetPasswordCooldown
                  ? t("navbar.reset_password_wait", selectedLang)
                  : t("navbar.forgot_password", selectedLang)}
            </button>
          )}
          {isSignUp && password.length > 0 && (
            <PasswordRequirements password={password} selectedLang={selectedLang} />
          )}
          <span className="btn-email" onClick={handleEmailSubmit}>
            {load && <CircularProgress />}
            {!load && (isSignUp ? t("navbar.signup_text", selectedLang) : t("navbar.signin_text", selectedLang))}
          </span>
          <button
            type="button"
            onClick={() => setIsSignUp(!isSignUp)}
            style={{
              background: "none",
              border: "none",
              color: "#666",
              cursor: "pointer",
              marginTop: "10px",
              textDecoration: "underline",
              fontSize: 14
            }}
          >
            {isSignUp
              ? t("navbar.already_have_account", selectedLang) + " " + t("navbar.signin_text", selectedLang)
              : t("navbar.dont_have_account", selectedLang) + " " + t("navbar.signup_text", selectedLang)}
          </button>
        </>
      )}

      {activeTab === TAB_SMS && !showOtpStep && (
        <>
          <input
            placeholder={t("navbar.phone_number", selectedLang)}
            onChange={(e) => setSmsPhoneInput(e.target.value.replace(/\D/g, "").slice(0, 10))}
            value={smsPhoneInput}
            type="tel"
          />
          <span className="btn-email" onClick={handleSendOtp}>
            {load && <CircularProgress />}
            {!load && t("navbar.send_otp", selectedLang)}
          </span>
        </>
      )}
    </div>
  );
};

export default LoginMethodSelect;
